/**
 * Copyright 2020 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const generateEventReport = `mutation GenerateEventReport($customer_id: String!, $event_id: String!) {
    generateEventReport(customer_id: $customer_id, event_id: $event_id)
  }
  `;
